export const FIELD_LABEL_RESOLUTION_CATEGORY = 'Resolution Category'
export const FIELD_LABEL_PEOPLE_OBSERVED = 'People Observed'
